import React, { useState, useEffect } from 'react';
import { Save, Phone, Mail, MapPin, Clock } from 'lucide-react';
import { api } from '../../api/client';
import { showToast } from '../../components/common/Toast';
import { formatUzPhone } from '../../utils/helpers';

export default function AdminContactPage() {
  const [contact, setContact] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/cms/contact')
      .then((res) => {
        if (res?.success) {
          const c = res.contact || {};
          setContact({
            ...c,
            primaryPhone: c.primaryPhone ? formatUzPhone(c.primaryPhone) : '+998 (97) 325-07-70',
            secondaryPhone: c.secondaryPhone ? formatUzPhone(c.secondaryPhone) : '+998 (88) 325-41-11',
          });
        }
      })
      .catch((err) => showToast(err.message, 'error'))
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (field, val) => {
    setContact((prev) => ({ ...prev, [field]: val }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await api.put('/cms/contact', contact);
      if (res?.success) {
        showToast('Kontakt rekvizitlari muvaffaqiyatli saqlandi!', 'success');
      }
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="py-12 text-center text-slate-400">Yuklanmoqda...</div>;
  }

  return (
    <form onSubmit={handleSave} className="space-y-6 max-w-4xl">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="font-serif text-lg font-bold text-slate-900">
            Kontakt Rekvizitlari
          </h2>
          <p className="text-xs text-slate-500">
            Sayt sarlavhasi, foter va aloqa sahifasida chiqadigan rasmiy kontaktlar
          </p>
        </div>

        <button
          type="submit"
          disabled={saving}
          className="inline-flex items-center px-5 py-2 text-xs font-semibold text-[#091322] bg-[#c5a880] hover:bg-[#d4b993] rounded shadow-sm transition-colors"
        >
          <Save className="w-4 h-4 mr-1.5" />
          {saving ? 'Saqlanmoqda...' : 'Saqlash'}
        </button>
      </div>

      <div className="bg-white rounded-lg border border-slate-200 shadow-2xs p-6 space-y-4 text-xs">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block font-semibold text-slate-700 uppercase mb-1">Asosiy Telefon *</label>
            <input
              type="text"
              value={contact.primaryPhone || ''}
              placeholder="+998 (97) 325-07-70"
              onChange={(e) => handleChange('primaryPhone', formatUzPhone(e.target.value, contact.primaryPhone, true))}
              className="w-full px-3 py-2 border rounded focus:border-[#c5a880] font-mono text-xs"
              required
            />
            <p className="text-[10px] text-slate-500 mt-1 font-mono">Format: +998 (97) 325-07-70</p>
          </div>

          <div>
            <label className="block font-semibold text-slate-700 uppercase mb-1">Qo‘shimcha Telefon</label>
            <input
              type="text"
              value={contact.secondaryPhone || ''}
              placeholder="+998 (88) 325-41-11"
              onChange={(e) => handleChange('secondaryPhone', formatUzPhone(e.target.value, contact.secondaryPhone, true))}
              className="w-full px-3 py-2 border rounded focus:border-[#c5a880] font-mono text-xs"
            />
            <p className="text-[10px] text-slate-500 mt-1 font-mono">Format: +998 (88) 325-41-11</p>
          </div>

          <div>
            <label className="block font-semibold text-slate-700 uppercase mb-1">Rasmiy Email *</label>
            <input
              type="email"
              value={contact.email || ''}
              onChange={(e) => handleChange('email', e.target.value)}
              className="w-full px-3 py-2 border rounded focus:border-[#c5a880]"
              required
            />
          </div>

          <div>
            <label className="block font-semibold text-slate-700 uppercase mb-1">Qo‘llab-quvvatlash Emaili</label>
            <input
              type="email"
              value={contact.supportEmail || ''}
              onChange={(e) => handleChange('supportEmail', e.target.value)}
              className="w-full px-3 py-2 border rounded focus:border-[#c5a880]"
            />
          </div>

          <div className="sm:col-span-2">
            <label className="block font-semibold text-slate-700 uppercase mb-1">Bosh Ofis Manzili (UZ) *</label>
            <input
              type="text"
              value={contact.addressUz || ''}
              onChange={(e) => handleChange('addressUz', e.target.value)}
              className="w-full px-3 py-2 border rounded focus:border-[#c5a880]"
              required
            />
          </div>

          <div className="sm:col-span-2">
            <label className="block font-semibold text-slate-700 uppercase mb-1">Bosh Ofis Manzili (RU)</label>
            <input
              type="text"
              value={contact.addressRu || ''}
              onChange={(e) => handleChange('addressRu', e.target.value)}
              className="w-full px-3 py-2 border rounded focus:border-[#c5a880]"
            />
          </div>

          <div className="sm:col-span-2">
            <label className="block font-semibold text-slate-700 uppercase mb-1">Ish Tartibi Matni (UZ)</label>
            <input
              type="text"
              value={contact.workingHoursUz || ''}
              onChange={(e) => handleChange('workingHoursUz', e.target.value)}
              className="w-full px-3 py-2 border rounded focus:border-[#c5a880]"
            />
          </div>
        </div>
      </div>
    </form>
  );
}
